/**
 * Get posts per page based on current viewport breakpoint
 * col-xl-4: 9 posts (3 per row × 3 rows)
 * col-lg-6, col: 8 posts (2 per row × 4 rows)
 */
function getPostsPerPageByBreakpoint() {
    const width = window.innerWidth;
    // Bootstrap breakpoints: xl >= 1200px
    if (width > 1024) {
        return 9;
    }
    // lg, md, sm, xs
    return 8;
}

function loadMoreArticles(button, list) {
    if (button.loading) return;

    let page = parseInt(button.dataset.page);
    let max  = parseInt(button.dataset.max);

    if (page > max) {        
        button.remove();
        return;
    }

    button.loading = true;
    button.disabled = true;
    button.textContent = 'Loading...';

    const formData = new FormData();
    formData.append('action', 'load_more_articles');
    formData.append('page', page);
    formData.append('posts_per_page', getPostsPerPageByBreakpoint());
    formData.append('lang', document.documentElement.lang.split('_')[0]);

    fetch(themeAjax.ajaxUrl, { method: 'POST', body: formData })
        .then(res => res.text())
        .then(html => {
            list.insertAdjacentHTML('beforeend', html);
            
            const nextPage = page + 1;
            button.dataset.page = nextPage;  

            if (nextPage > max) {            
                button.remove();
            } else {
                button.disabled = false;
                button.textContent = 'Load more';
            }

            button.loading = false;
        })
        .catch(error => {
            console.error('Error loading more articles:', error);
            button.disabled = false;
            button.textContent = 'Load more';
            button.loading = false;
        });
}

function initLoadMoreArticles() {
    const button = document.getElementById('load-more');
    const list   = document.getElementById('article-list');

    if (!button || !list) return;

    button.addEventListener('click', (e) => {
        e.preventDefault();
        loadMoreArticles(button, list);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initLoadMoreArticles();
});
